import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      submit: "Submit",
      alreadyRegistered: "Already registered?",
      clickHereToLogin: "Click here to login",
      notRegistered: "Not registered?",
      clickHereToRegister: "Click here to register",
      myBadge: "My Badge",
      floorPlan: "Floor Plan",
      attendees: "Attendees",
      exhibitors: "Exhibitors",
      products: "Products",
      conferences: "Conferences",
      networking: "Networking",
      myAgenda: "My Agenda",
      sponsors: "Sponsors",
      eventName: "Event Name",
      "Email/UserId": "Email/UserId",
      Password: "Password",
      "Remember Me": "Remember Me",
      Enter: "Enter",
      "Forgot Password?": "Forgot Password?",
      "Not registered?": "Not registered?",
      "Click here to signup": "Click here to signup",
      Required: "Required",
      Dashboard: "Dashboard",
      MyBadge: "Badge",
      BadgeNotReady:
        "Sorry {{name}}, your badge is not ready yet. Please try again later.",
      DownloadAsPDF: "Download as PDF",
      DownloadAsJPG: "Download as JPG",
      PoweredBy: "Powered by Eventegration",
      LoginPanel: "Login Panel",
      Back: "Back",
      Home: "Home",
      Contact: "Contact",
      FloorPlan: "FloorPlan",
      FloorPlanNotReady:
        "Sorry, the floor plan is not ready yet. Please try again later.",
      Logout: "Logout",
      Profile: "Profile",
      underPatronage: "Under the Patronage of",
      sultanateOfOman: "Sultanate of Oman",
      ministryOfAgriculture: "Ministry of Agriculture",
      hostedBy: "Hosted By",
      sponsorsAndPartners: "Sponsors and Partners",
      strategicPartners: "Strategic Partners",
      organizedBy: "Organized By",
      ConferenceProgram: "Conference Program",
      StrategicProgram: "Strategic Conference Program",
      MunicipalWaterProgram: "Municipal & Water Program",
      "Produced/IndustrialWaterProgram": "Produced / Industrial Water Program",
      dashboard: "Dashboard",
      sponsorsList: "Sponsors List",
      name: "Name",
      company: "Company",
      designation: "Designation",
      country: "Country",
      itemsPerPage: "Items per page",
      ten: "10",
      twentyFive: "25",
      fifty: "50",
      oneHundred: "100",
      all: "All",
      nosponsorsFound: "Sorry, no sponsors found.",
      filter: "Filter",
      sort: "Sort",
      search: "Search products...",
      tenItems: "10",
      twentyFiveItems: "25",
      fiftyItems: "50",
      hundredItems: "100",
      allItems: "All",
      noproductsFound: "Sorry, no products found.",
      error: "Error",
      loading: "Loading...",
      filterBy: "Filter by",
      sortBy: "Sort by",
      apply: "Apply",
      clear: "Clear",
      attendeesList: "Attendees List",
      searchAttendees: "Search attendees...",
      searchExhibitors: "Search exhibitors...",
      noattendeesFound: "Sorry, no attendees found.",
      noxhibitorsFound: "Sorry, no exhibitors found.",
      exhibitorsList: "Exhibitors List",
      searchBar: {
        searchPlaceholder: "Search {{role}}",
      },
      filterModal: {
        filter: "Filter",
        role: "Role",
        company: "Company",
        designation: "Designation",
        country: "Country",
        done: "Done",
        clear: "Clear",
        apply: "Apply",
        clearAll: "Clear All",
      },
      attendeeModal: {
        role: "Role",
        removeFromNetwork: "Remove from My Network",
        addToNetwork: "Add to My Network",
        skip: "Skip",
        noMoreAttendees: "No more attendees to show",
        close: "Close",
        stallNo: "Stall No",
        bio: "Company Bio",
        email: "Email",
        country: "Country",
        designation: "Designation",
        company: "Company",
        name: "Name",
        add: "Add",
        remove: "Remove",
        addedSuccess: "Attendee added to your network successfully",
        removedSuccess: "Attendee removed from your network successfully",
        addedFailure: "Failed to add attendee to your network",
        removedFailure: "Failed to remove attendee from your network",
      },
      floorPlanTitle: "Oman Water Week 2025 Floor Plan",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      downloadPDF: "Download as PDF",
      floorPlanNotReady: "The floor plan is not ready yet.",
      profile: {
        imageRequirements: "Allowed formats: PNG, JPEG, JPG (max 2MB)",
        bioCharacterCount: "Characters: {{count}}/{{max}}",
        fields: {
          fullName: "Full Name",
          email: "Email",
          company: "Company",
          designation: "Designation",
          stallNo: "Stall No",
          bio: "Company Bio",
          country: "Country",
        },
        buttons: {
          updatePassword: "Update Password",
          editProfile: "Edit Profile",
          cancel: "Cancel",
          saveChanges: "Save Changes",
        },
      },
      updatePassword: {
        title: "Change/Update Password",
        oldPassword: "Old Password",
        newPassword: "New Password",
        confirmNewPassword: "Confirm New Password",
        updateButton: "Update",
        fillAllFields: "Please fill all fields",
        passwordRequirements:
          "New password must be at least 8 characters long, contain at least one letter, one number, and one special character",
        passwordMismatch: "New password and confirm password do not match",
        success: "Password updated",
      },
      "Forgot Password": "Forgot Password",
      Email: "Email",
      Submit: "Submit",
      Cancel: "Cancel",
      "Password reset link sent to your email.":
        "Password reset link sent to your email.",
      "Failed to send password reset link.":
        "Failed to send password reset link.",
      "attendeeModal.addedSuccess":
        "Attendee added to your network successfully",
      "attendeeModal.removedSuccess":
        "Attendee removed from your network successfully",
      "attendeeModal.addedFailure": "Failed to add attendee to your network",
      "attendeeModal.removedFailure":
        "Failed to remove attendee from your network",
      "attendeeModal.stallNumber": "Stall Number",
      Filters: "Filters",
      FilterOptions: "Filter Options",
      ApplyFilters: "Apply Filters",
      ClearAll: "Clear All",
      Search: "Search",
      myNetworkingList: "My Networking List",
      productsList: "Products List",
      searchProducts: "Search products...",
      tryAdjustingFilters: "Try adjusting filters",
      MyAgenda: "My Agenda",
      WelcomeBack: "Welcome back",
      signToContinue: "Sign in to continue",
      SignIn: "Sign In",
      ResetPassword: "Reset Password",
      SendLink: "Send Link",
      RememberMe: "Remember Me",
      "ForgotPassword?": "Forgot Password?",
      myProducts: "My Products",
      noProductFound: "Sorry, no products found.",
      youdidnotcretaedproductyet: "You did not create any product yet",
      EditProduct: "Edit Product",
      DeleteProduct: "Delete Product",
      AddNewProduct: "Add New Product",
      ProductName: "Product Name",
      ProductDescription: "Product Description",
      UploadProductImage: "Upload Product Image",
      ForBestViewUseDimension500x300: "For best view, use dimension 500x300",
      UpdateMyProduct: "Update My Product",
      ListMyProduct: "List My Product",
      SomethingWentWrong: "Something went wrong",
      productUpdatedSuccessfully: "Product updated successfully",
      errorUpdatingProduct: "Error updating product",
      StallNo: "Stall No",
      ConfirmDelete: "Confirm Delete",
      AreYouSureYouWantToDeleteThisProduct:
        "Are you sure you want to delete this product?",
      productDeletedSuccessfully: "Product deleted successfully",
      Delete: "Delete",
      productDescription: "Product Description",
      exhibitorDetails: "Exhibitor Details",
      AboutCompany: "About Company",
      Company: "Company",
      companyBio: "Company Bio",
      About: "About",
      showingResults: "Showing results",
      SmartCitiesPartner: "Smart Cities Partner",
      PlatinumSponsors: "Platinum Sponsors",
      GoldSponsors: "Gold Sponsors",
      LanyardSponsor: "Lanyard Sponsor",
      SupportingPartners: "Supporting Partners",
      noexhibitorFound: "Sorry, no exhibitor found.",
      noattendeeFound: "Sorry, no attendee found.",
      "profile.fields.fullName": "Full Name",
      "profile.fields.email": "Email",
      "profile.fields.company": "Company",
      "profile.fields.designation": "Designation",
      "profile.fields.country": "Country",
      "profile.fields.stallNo": "Stall No.",
      "profile.fields.bio": "Bio",
      "profile.fields.companyName": "Company Name",
      "profile.fields.website": "Website",
      "profile.fields.fasciaBoard": "Fascia Board",
      "profile.fields.brands": "Brands",
      "profile.fields.linkedIn": "LinkedIn",
      "profile.fields.sponsorship_level": "Sponsorship Level",
      "profile.fields.companyProfile": "Company Profile",
      "profile.buttons.updatePassword": "Update Password",
      "profile.buttons.editProfile": "Edit Profile",
      "profile.buttons.cancel": "Cancel",
      "profile.buttons.saveChanges": "Save Changes",
      "profile.imageRequirements": "Image Requirements",
      Stall: "Stall",
      OurProducts: "Our Products",
      TeamMembers: "Team Members",
      AddToMyConnection: "Add to My Connection",
      removeFromMyConnection: "Remove from My Connection",
      CompanyName: "Company Name",
      Country: "Country",
      Website: "Website",
      FasciaBoard: "Fascia Board",
      Brands: "Brands",
      TypeAndPressEnter: "Type and press enter",
      UploadLogo: "Upload Logo",
      CompanyProfile: "Company Profile",
      UpdateExhibitor: "Update Exhibitor",
      AddExhibitor: "Add Exhibitor",
      EditExhibitor: "Edit Exhibitor",
      AddNewExhibitor: "Add New Exhibitor",
      Close: "Close",
      "exhibitorModal.addedSuccess": "Exhibitor added successfully",
      "exhibitorModal.removedSuccess": "Exhibitor removed successfully",
      "searchBar.noResults": "No results found",
      speakers: "Speakers",
      speakersList: "Speakers List",
      speaker: "Speaker",
      nospeakerFound: "Sorry, no speaker found.",
      speakerDetails: "Speaker Details",
      speakerBio: "Speaker Bio",
      speakerName: "Speaker Name",
      speakerDesignation: "Speaker Designation",
      speakerCompany: "Speaker Company",
      speakerCountry: "Speaker Country",
      speakerEmail: "Speaker Email",
      speakerRole: "Speaker Role",
      "speakerModal.addedSuccess": "Speaker added to your network successfully",
      searchSpeakers: "Search Speakers",
      areYouSureToDelete: "Are you sure you want to delete this sponsor?",
      sponsorDeleted: "Sponsor deleted successfully",
      deleteError: "Error deleting sponsor",
      sponsorAddedSuccessfully: "Sponsor added successfully",
      errorAddingSponsor: "Error adding sponsor",
      errorUploadingImage: "Error uploading image",
      sponsorUpdated: "Sponsor updated successfully",
      errorUpdatingSponsor: "Error updating sponsor",
      noSponsorsFound: "No sponsors found",
      searchSponsors: "Search sponsors",
      Day: "Day",
      Editsponsor: "Edit Sponsor",
      AddNewsponsor: "Add New Sponsor",
      sponsorship_level: "Sponsorship Level",
      Updatesponsor: "Update Sponsor",
      Addsponsor: "Add Sponsor",
      "sponsorModal.addedSuccess": "Sponsor addedd successfully",
      sessionAddedToAgenda: "Session added to my agenda successfully",
      sessionRemovedFromAgenda: "Session removed from my agenda successfully",
      sessionAddedFailure: "Session added to my agenda failed",
      sessionRemovedFailure: "Session removed from my agenda failed",
      sessionAlreadyAdded: "Session already added to my agenda",
      sessionNotAdded: "Session not added to my agenda",
      sessionNotRemoved: "Session not removed from my agenda",
      "Install App": "Install App",
      ios_install_instructions: "Add this app to your home screen:",
      "1. Tap share icon": "1. Tap the share icon",
      '2. Select "Add to Home Screen"': '2. Select "Add to Home Screen"',
      confirmDeleteExhibitor: "Are you sure you want to delete this exhibitor?",
      exhibitorDeletedSuccessfully: "Exhibitor deleted successfully",
      errorDeletingExhibitor: "Error deleting exhibitor",
      fillAllRequiredFields: "Please fill all required fields",
      uploadLogoRequired: "Please upload a logo",
      CreateAccount: "Create Account",
      BackToLogin: "Back to Login",
      ChooseParticipationType: "Choose Participation Type",
      EnterCredentials: "Enter Credentials",
      supportedBy: "Supported By",
      AgendaInnovationProgram: "Innovation Lab Program",
      HydrogenWorkshopProgram: "Hydrogen Workshop Program",
      WaterTalksProgram: "Water Talks Program",
    },
  },
  ar: {
    translation: {
      AgendaInnovationProgram: "برنامج المختبرات الابتكارية",
      HydrogenWorkshopProgram: "برنامج الورش الهيدروجينية",
      WaterTalksProgram: "برنامج الحديث عن المياه",
      supportedBy: "مدعوم من",
      CreateAccount: "إنشاء حساب",
      BackToLogin: "العودة لتسجيل الدخول",
      ChooseParticipationType: "اختر نوع المشاركة",
      EnterCredentials: "أدخل بيانات الدخول",
      speakers: "المتحدثون",
      searchSpeakers: "البحث عن المتحدثين...",
      searchExhibitors: "البحث عن العارضين...",
      speaker: "المتحدث",
      speakersList: "قائمة المتحدثين",
      nospeakerFound: "عذراً، لم يتم العثور على متحدث.",
      speakerDetails: "تفاصيل المتحدث",
      speakerBio: "سيرة المتحدث",
      speakerName: "اسم المتحدث",
      speakerDesignation: "مسمى المتحدث",
      speakerCompany: "شركة المتحدث",
      speakerCountry: "بلد المتحدث",
      speakerEmail: "بريد المتحدث",
      speakerRole: "دور المتحدث",
      "speakerModal.addedSuccess": "تمت إضافة المتحدث إلى شبكتك بنجاح",
      submit: "إرسال",
      alreadyRegistered: "مسجل بالفعل؟",
      clickHereToLogin: "انقر هنا لتسجيل الدخول",
      notRegistered: "غير مسجل؟",
      clickHereToRegister: "اضغط هنا للتسجيل",
      myBadge: "شهادتي",
      floorPlan: "خريطة الطابق",
      attendees: "الحضور",
      exhibitors: "العارضين",
      exhibitor: "العارضين",
      products: "المنتجات",
      conferences: "المؤتمرات",
      networking: "التواصل",
      myAgenda: "جدولي",
      sponsors: "الرعاة",
      sponsor: "الرعاة",
      eventName: "اسم الحدث",
      "Email/UserId": "البريد الإلكتروني / اسم المستخدم",
      Password: "كلمة المرور",
      "Remember Me": "تذكرني",
      Enter: "تسجيل الدخول",
      "Forgot Password?": "نسيت كلمة المرور؟",
      "Not registered?": "غير مسجل؟",
      "Click here to signup": "اضغط هنا للتسجيل",
      Required: "مطلوب",
      Dashboard: "لوحة القيادة",
      MyBadge: "شارة",
      BadgeNotReady:
        "عذراً {{name}}، شارتك غير جاهزة بعد. يرجى المحاولة مرة أخرى لاحقاً.",
      DownloadAsPDF: "تحميل كملف PDF",
      DownloadAsJPG: "تحميل كملف JPG",
      PoweredBy: "مشغل بواسطة Eventegration",
      LoginPanel: "لوحة تسجيل الدخول",
      Back: "رجوع",
      Home: "الصفحة الرئيسية",
      Contact: "اتصل",
      FloorPlan: "مخطط الطابق",
      FloorPlanNotReady:
        "عذراً، خريطة الطابق غير جاهزة بعد. يرجى المحاولة مرة أخرى لاحقاً.",
      Logout: "تسجيل الخروج",
      Profile: "الملف الشخصي",
      underPatronage: "تحت الرعاية",
      sultanateOfOman: "سلطنة عمان",
      ministryOfAgriculture: "وزارة الزراعة",
      hostedBy: "المنظم",
      sponsorsAndPartners: "الرعاة والشركاء",
      strategicPartners: "الشركاء الاستراتيجيين",
      organizedBy: "المنظم",
      ConferenceProgram: "برنامج المؤتمر",
      StrategicProgram: "برنامج المؤتمر الاستراتيجي",
      MunicipalWaterProgram: "برنامج المياه البلدي والمجاري",
      "Produced/IndustrialWaterProgram": "برنامج المياه المنتجة والصناعية",
      dashboard: "لوحة التحكم",
      sponsorsList: "قائمة الرعاة",
      name: "الاسم",
      company: "الشركة",
      designation: "المنصب",
      country: "الدولة",
      itemsPerPage: "العناصر في الصفحة",
      ten: "١٠",
      twentyFive: "٢٥",
      fifty: "٥٠",
      oneHundred: "١٠٠",
      all: "الكل",
      nosponsorsFound: "عذرا، لم يتم العثور على رعاة.",
      productsList: "قائمة المنتجات",
      filter: "تصفية",
      sort: "ترتيب",
      search: "البحث عن منتجات...",
      tenItems: "١٠",
      twentyFiveItems: "٢٥",
      fiftyItems: "٥٠",
      hundredItems: "١٠٠",
      allItems: "الكل",
      noproductsFound: "عذراً، لم يتم العثور على منتجات.",
      error: "خطأ",
      loading: "جاري التحميل...",
      filterBy: "تصفية حسب",
      sortBy: "ترتيب حسب",
      apply: "تطبيق",
      clear: "مسح",
      attendeesList: "قائمة الحضور",
      myNetworkingList: "قائمة شبكتي",
      searchAttendees: "البحث عن الحضور...",
      searchExhibitors: "البحث عن العارضين...",
      noattendeesFound: "عذراً، لم يتم العثور على حضور.",
      noexhibitorsFound: "عذراً، لم يتم العثور على معرضين.",
      exhibitorsList: "قائمة المعرضين",
      searchBar: {
        searchPlaceholder: "ابحث عن {{role}}",
      },
      filterModal: {
        filter: "تصفية",
        role: "الدور",
        company: "الشركة",
        designation: "المنصب",
        country: "الدولة",
        done: "تم",
        clear: "مسح",
        apply: "تطبيق",
        clearAll: "مسح الكل",
      },
      attendeeModal: {
        role: "الدور",
        removeFromNetwork: "إزالة من شبكتي",
        addToNetwork: "إضافة إلى شبكتي",
        skip: "تخطي",
        noMoreAttendees: "لا توجد مزيد من الحضور لعرضها",
        close: "إغلاق",
        stallNo: "رقم الجناح",
        bio: "السيرة الذاتية للشركة",
        email: "البريد الإلكتروني",
        country: "الدولة",
        designation: "المنصب",
        company: "الشركة",
        name: "الاسم",
        add: "إضافة",
        remove: "إزالة",
        addedSuccess: "تمت إضافة الحضور إلى شبكتك بنجاح",
        removedSuccess: "تمت إزالة الحضور من شبكتك بنجاح",
        addedFailure: "فشلت إضافة الحضور إلى شبكتك",
        removedFailure: "فشلت إزالة الحضور من شبكتك",
      },
      floorPlanTitle: "خطة الطابق لأسبوع المياه في عمان ٢٠٢٥",
      zoomIn: "تكبير",
      zoomOut: "تصغير",
      downloadPDF: "تحميل كملف PDF",
      floorPlanNotReady: "خطة الطابق غير جاهزة بعد.",
      profile: {
        imageRequirements:
          "الصيغ المسموح بها: PNG، JPEG، JPG (حد أقصى 2 ميغابايت)",
        bioCharacterCount: "الأحرف: {{count}}/{{max}}",
        fields: {
          fullName: "الاسم الكامل",
          email: "البريد الإلكتروني",
          company: "الشركة",
          designation: "المسمى الوظيفي",
          stallNo: "رقم الجناح",
          bio: "السيرة الذاتية للشركة",
          country: "الدولة",
        },
        buttons: {
          updatePassword: "تحديث كلمة المرور",
          editProfile: "تعديل الملف",
          cancel: "إلغاء",
          saveChanges: "حفظ التغييرات",
        },
      },
      updatePassword: {
        title: "تغيير/تحديث كلمة المرور",
        oldPassword: "كلمة المرور القديمة",
        newPassword: "كلمة المرور الجديدة",
        confirmNewPassword: "تأكيد كلمة المرور الجديدة",
        updateButton: "تحديث",
        fillAllFields: "يرجى ملء جميع الحقول",
        passwordRequirements:
          "يجب أن تكون كلمة المرور الجديدة مكونة من 8 أحرف على الأقل، وتحتوي على حرف واحد على الأقل، ورقم واحد، وحرف خاص واحد",
        passwordMismatch: "كلمة المرور الجديدة وتأكيد كلمة المرور غير متطابقين",
        success: "تم تحديث كلمة المرور",
      },
      "Forgot Password": "نسيت كلمة المرور",
      Email: "البريد الإلكتروني",
      Submit: "إرسال",
      Cancel: "إلغاء",
      "Password reset link sent to your email.":
        "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.",
      "Failed to send password reset link.":
        "فشل في إرسال رابط إعادة تعيين كلمة المرور.",
      "attendeeModal.addedSuccess": "تمت إضافة الحضور إلى شبكتك بنجاح",
      "attendeeModal.removedSuccess": "تمت إزالة الحضور من شبكتك بنجاح",
      "attendeeModal.addedFailure": "فشلت إضافة الحضور إلى شبكتك",
      "attendeeModal.removedFailure": "فشلت إزالة الحضور من شبكتك",
      "attendeeModal.stallNumber": "رقم الجناح",
      Filters: "مرشحات",
      FilterOptions: "خيارات التصفية",
      ApplyFilters: "تطبيق المرشحات",
      ClearAll: "امسح الكل",
      Search: "بحث",
      searchProducts: "البحث عن المنتجات...",
      tryAdjustingFilters: "حاول ضبط المرشحات",
      MyAgenda: "جدولي",
      WelcomeBack: "مرحبا بعودتك",
      signToContinue: "تسجيل الدخول للمتابعة",
      SignIn: "تسجيل الدخول",
      ResetPassword: "إعادة تعيين كلمة المرور",
      SendLink: "إرسال الرابط",
      RememberMe: "تذكرني",
      "ForgotPassword?": "نسيت كلمة المرور؟",
      myProducts: "منتجاتي",
      noProductFound: "عذراً، لم يتم العثور على منتجات.",
      youdidnotcretaedproductyet: "لم تقم بإنشاء أي منتج بعد",
      EditProduct: "تعديل المنتج",
      DeleteProduct: "حذف المنتج",
      AddNewProduct: "إضافة منتج جديد",
      ProductName: "اسم المنتج",
      ProductDescription: "وصف المنتج",
      UploadProductImage: "تحميل صورة المنتج",
      ForBestViewUseDimension500x300:
        "للحصول على أفضل عرض، استخدم الأبعاد 500x300",
      UpdateMyProduct: "تحديث منتجي",
      ListMyProduct: "قائمة منتجاتي",
      SomethingWentWrong: "حدث خطأ ما",
      productUpdatedSuccessfully: "تم تحديث المنتج بنجاح",
      errorUpdatingProduct: "حدث خطأ أثناء تحديث المنتج",
      StallNo: "رقم الجناح",
      ConfirmDelete: "تأكيد الحذف",
      AreYouSureYouWantToDeleteThisProduct: "هل أنت متأكد من حذف هذا المنتج؟",
      productDeletedSuccessfully: "تم حذف المنتج بنجاح",
      Delete: "حذف",
      productDescription: "وصف المنتج",
      exhibitorDetails: "تفاصيل العارض",
      AboutCompany: "عن الشركة",
      Company: "الشركة",
      companyBio: "نبذة عن الشركة",
      About: "حول",
      showingResults: "عرض النتائج",
      SmartCitiesPartner: "شريك المدن الذكية",
      PlatinumSponsors: "الرعاة البلاتينيين",
      GoldSponsors: "الرعاة الذهبيين",
      LanyardSponsor: "راعي الشارة",
      SupportingPartners: "الشركاء المساندين",
      noexhibitorFound: "عذراً، لم يتم العثور على عارضين.",
      noattendeeFound: "عذراً، لم يتم العثور على حضور.",
      "profile.fields.fullName": "الاسم الكامل",
      "profile.fields.email": "البريد الإلكتروني",
      "profile.fields.company": "الشركة",
      "profile.fields.designation": "المنصب",
      "profile.fields.country": "الدولة",
      "profile.fields.stallNo": "رقم الكشك",
      "profile.fields.bio": "السيرة الذاتية",
      "profile.fields.companyName": "اسم الشركة",
      "profile.fields.website": "الموقع الإلكتروني",
      "profile.fields.fasciaBoard": "لوحة الفاسيا",
      "profile.fields.brands": "العلامات التجارية",
      "profile.fields.companyProfile": "ملف الشركة",
      "profile.fields.linkedIn": "لينكد إن",
      "profile.fields.sponsorship_level": "مستوى الرعاية",
      "profile.buttons.updatePassword": "تحديث كلمة المرور",
      "profile.buttons.editProfile": "تعديل الملف الشخصي",
      "profile.buttons.cancel": "إلغاء",
      "profile.buttons.saveChanges": "حفظ التغييرات",
      "profile.imageRequirements": "متطلبات الصورة",
      Stall: "المعرض",
      OurProducts: "منتجاتنا",
      TeamMembers: "أفراد الفريق",
      AddToMyConnection: "إضافة إلى اتصالي",
      removeFromMyConnection: "إزالة من اتصالي",
      CompanyName: "اسم الشركة",
      Country: "الدولة",
      Website: "الموقع الإلكتروني",
      FasciaBoard: "لوحة الفاسكيا",
      Brands: "العلامات التجارية",
      TypeAndPressEnter: "اكتب واضغط على Enter",
      UploadLogo: "تحميل الشعار",
      CompanyProfile: "ملف الشركة",
      UpdateExhibitor: "تحديث المعرض",
      AddExhibitor: "إضافة معرض",
      EditExhibitor: "تعديل المعرض",
      AddNewExhibitor: "إضافة معرض جديد",
      Close: "إغلاق",
      "exhibitorModal.addedSuccess": "تم إضافة المعرض بنجاح",
      "exhibitorModal.removedSuccess": "تم إزالة المعرض بنجاح",
      "searchBar.noResults": "لا توجد نتائج",
      areYouSureToDelete: "هل أنت متأكد من حذف هذا الراعي؟",
      sponsorDeleted: "تم حذف الراعي بنجاح",
      deleteError: "خطأ في حذف الراعي",
      sponsorAddedSuccessfully: "تم إضافة الراعي بنجاح",
      errorAddingSponsor: "خطأ في إضافة الراعي",
      errorUploadingImage: "خطأ في تحميل الصورة",
      sponsorUpdated: "تم تحديث الراعي بنجاح",
      errorUpdatingSponsor: "خطأ في تحديث الراعي",
      noSponsorsFound: "لم يتم العثور على رعاة",
      searchSponsors: "بحث عن رعاة",
      Day: "يوم",
      Editsponsor: "تعديل الراعي",
      AddNewsponsor: "إضافة راعي جديد",
      sponsorship_level: "مستوى الرعاية",
      Updatesponsor: "تحديث الراعي",
      Addsponsor: "إضافة راعي",
      "sponsorModal.addedSuccess": "تمت إضافة الراعي بنجاح",
      sessionAddedToAgenda: "تمت إضافة الجلسة إلى جدولك بنجاح",
      sessionRemovedFromAgenda: "تمت إزالة الجلسة من جدولك بنجاح",
      sessionAddedFailure: "فشلت إضافة الجلسة إلى جدولك",
      sessionRemovedFailure: "فشلت إزالة الجلسة من جدولك",
      sessionAlreadyAdded: "الجلسة مضافة بالفعل إلى جدولك",
      sessionNotAdded: "لم تتم إضافة الجلسة إلى جدولك",
      sessionNotRemoved: "لم تتم إزالة الجلسة من جدولك",
      "Install App": "تثبيت التطبيق",
      ios_install_instructions: "أضف هذا التطبيق إلى شاشتك الرئيسية:",
      "1. Tap share icon": "١. اضغط على أيقونة المشاركة",
      '2. Select "Add to Home Screen"': '٢. اختر "إضافة إلى الشاشة الرئيسية"',
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "ar",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
